<template>
    <v-btn
        :href="href"
        :to="to"
        :target="open_in_new_tab ? '_blank' : null"
        :color="color"
        class="pa-0 mb-0 text-decoration-underline"
        :style="`text-transform: ${text_transform}; font-size: ${font_size}; font-weight: ${font_weight}; height: ${height}; min-width: ${min_width}; transform: ${transform}; letter-spacing: ${letter_spacing};`"
        :aria-label="aria_label"
        text
        small
        v-on="$listeners"
        @click="onClick"
    >
        <slot>
            <span v-if="text">{{ text }}</span>
        </slot>
        <sup v-if="open_in_new_tab">
            <slot name="icon">
                <v-icon
                    size="14"
                    aria-hidden="true"
                >
                    mdi-arrow-top-right
                </v-icon>
            </slot>
        </sup>
    </v-btn>
</template>

<script>
/**
 * A reusable link component that can handle both internal and external links,
 * with options for opening in a new tab and customizing appearance.
 */

export default {
    name: 'RcLink',

    props: {
        href: {
            type: String,
            default: null
        },

        to: {
            type: [String, Object],
            default: null
        },

        text: {
            type: String,
            default: ''
        },

        color: {
            type: String,
            default: 'primary'
        },

        inline: {
            type: Boolean,
            default: false
        },

        open_in_new_tab: {
            type: Boolean,
            default: true
        },

        text_transform: {
            type: String,
            default: 'uppercase',
            validator: function (value) {
                return ['none', 'capitalize', 'uppercase', 'lowercase', 'initial', 'inherit'].includes(value);
            }
        }

    },

    computed: {
        font_size() {
            return this.inline ? '16px' : '12px';
        },

        font_weight() {
            return this.inline ? 'normal' : '500';
        },

        height() {
            return this.inline ? 'auto' : '28px';
        },

        min_width() {
            return this.inline ? 'auto' : '50px';
        },

        transform() {
            // nudge for visual inline alignment
            return this.inline ? 'translateY(-1px)' : 'none';
        },

        letter_spacing() {
            return this.inline ? 'normal' : '0.0892857143em';
        },

        aria_label() {
            if (this.open_in_new_tab) {
                return this.href ? `External link opens in a new tab: ${this.text}` : `Link opens in a new tab: ${this.text}`;
            }
            return this.href ? `External link: ${this.text}` : this.text;
        }
    },

    methods: {
        onClick(event) {
            this.$emit('click', event);
        }
    }
};
</script>

<style lang="scss" scoped>
.v-btn {
    transition: filter 0.2s ease;
    white-space: normal;

    &::before {
        opacity: 0 !important;
    }

    &:hover {
        filter: brightness(90%);
    }

    :deep(.v-btn__content) {
        max-width: 100%;
    }
}
</style>